<template>
  <a-drawer :visible="visible" :width="1100" title="当前优惠券使用记录" @close="close" destroy-on-close>
    <!-- 检索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="用户名称" allow-clear />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="订单号">
              <a-input v-model="query.orderNo" placeholder="订单号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="使用状态">
              <a-select v-model="query.status" placeholder="全部" allow-clear>
                <a-select-option :value="1">冻结</a-select-option>
                <a-select-option :value="2">已使用</a-select-option>
                <a-select-option :value="3">已返还</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      row-key="userId"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"

      @change="changeSize"
    >
      <span slot="amount" slot-scope="text">¥{{ text.toFixed(2) }}</span>
      <span slot="status" slot-scope="text">
        {{ { 1: '冻结', 2: '已使用', 3: '已返还' }[text] || '-' }}
      </span>
      <span slot="useTime" slot-scope="text">{{ text || '-' }}</span>
    </a-table>
  </a-drawer>
</template>

<script>
import { getUserCouponStatList } from '@/api/coupon/controller/userCouponStat'

export default {
  name: 'UserCouponStatDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      couponId: '',
      list: [],
      total: 0,
      query: { pageNum: 1, pageSize: 10 },
      columns: [
        { title: '用户名称', dataIndex: 'userName', width: 160, align: 'center' },
        { title: '联系方式', dataIndex: 'phone', align: 'center' },
        { title: '订单号', dataIndex: 'orderNo', align: 'center', ellipsis: true },
        { title: '金额', dataIndex: 'amount', align: 'center', scopedSlots: { customRender: 'amount' } },
        { title: '使用状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '使用时间', dataIndex: 'useTime', align: 'center', scopedSlots: { customRender: 'useTime' } },
        // { title: '插入时间', dataIndex: 'createTime', align: 'center' }
      ],
    }
  },
  computed: {
    pagination() {
      return {
        current: this.query.pageNum,
        pageSize: this.query.pageSize,
        total: this.total,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      }
    },
  },
  methods: {
    open(options = {}) {
      console.log(options)
      this.query = {
        pageNum: 1,
        pageSize: 10,
        couponId: options.id || '',
        whType: options.whType || '',
      }
      this.couponId = options.id || ''
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
    },
    getList() {
      this.loading = true
      getUserCouponStatList(this.query)
        .then((res) => {
          this.list = res.data.records
          this.total = res.data.total
        })
        .finally(() => (this.loading = false))
    },
    handleQuery() {
      this.query.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        couponId: this.couponId || '',
        whType: this.query.whType || '',
      }
      this.getList()
    },
    changeSize({ current, pageSize }) {
      this.query.pageNum = current
      this.query.pageSize = pageSize
      this.getList()
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
